import moment from 'moment';
import { BroadcastMonth } from 'broadcastCalendar/BroadcastMonth';

export default class Month {

  dateInMonth: moment;

  constructor(date: moment) {
    this.dateInMonth = date;
  }

  static fromMoment(date: moment): Month {
    return new Month(date);
  }

  static fromBroadcastMonth(month: BroadcastMonth) {
    return new Month(month.lastDay());
  }

  asMoment(): moment {
    return this.dateInMonth;
  }

  asBroadcastMonth(): BroadcastMonth {
    return BroadcastMonth.on(this.dateInMonth);
  }
}



// WEBPACK FOOTER //
// ./src/common/components/monthlyDateRangePicker/Month.js